import { render } from "./camera-photos.vue?vue&type=template&id=0c316046"
import script from "./camera-photos.vue?vue&type=script&lang=js"
export * from "./camera-photos.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a2019/Documents/Project/MiniApp/miniapp_wing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__